module.exports = __webpack_public_path__ + "img/img_authentication_background.c498ced.png";